// extracted by mini-css-extract-plugin
export var orderSummary = "_qb-0";
export var showMoreLessButton = "_qb-1";